import { Matrix } from "../../maths/Matrix";
import { RenderSpriteData, Value2D } from "../shader/d2/value/Value2D";
import { RenderInfo } from "../../renders/RenderInfo";
import { SubmitBase } from "../submit/SubmitBase";
export class CharSubmitCache {
    constructor(ctx) {
        this._data = [];
        this._ndata = 0;
        this._clipid = -1;
        this._clipMatrix = new Matrix();
        this._enable = false;
        this._clipid = ctx._clipInfoID;
        ctx._globalClipMatrix.copyTo(this._clipMatrix);
    }
    clear() {
        this._tex = null;
        this._imgId = -1;
        this._ndata = 0;
        this._enable = false;
        this._colorFiler = null;
    }
    destroy() {
        this.clear();
        this._data.length = 0;
        this._data = null;
    }
    add(ctx, tex, imgid, pos, uv, color) {
        if (this._ndata > 0 && (this._tex != tex || this._imgId != imgid ||
            (this._clipid >= 0 && this._clipid != ctx._clipInfoID))) {
            this.submit(ctx);
        }
        this._clipid = ctx._clipInfoID;
        ctx._globalClipMatrix.copyTo(this._clipMatrix);
        this._tex = tex;
        this._imgId = imgid;
        this._colorFiler = ctx._colorFiler;
        this._data[this._ndata] = pos;
        this._data[this._ndata + 1] = uv;
        this._data[this._ndata + 2] = color;
        this._ndata += 3;
    }
    getPos() {
        if (CharSubmitCache.__nPosPool == 0)
            return new Array(8);
        return CharSubmitCache.__posPool[--CharSubmitCache.__nPosPool];
    }
    enable(value, ctx) {
        if (value === this._enable)
            return;
        this._enable = value;
        this._enable || this.submit(ctx);
    }
    submit(ctx) {
        var n = this._ndata;
        if (!n)
            return;
        ctx.drawLeftData();
        let shaderValue = Value2D.create(RenderSpriteData.Texture2D);
        ctx.fillShaderValue(shaderValue);
        shaderValue.textureHost = this._tex;
        let _mesh = ctx._mesh = ctx._meshQuatTex;
        let submit = ctx._curSubmit = SubmitBase.create(ctx, _mesh, shaderValue);
        submit._key.other = this._imgId;
        submit._colorFiler = this._colorFiler;
        var cm = shaderValue.clipMatDir;
        let clipInfo = this._clipMatrix;
        cm.x = clipInfo.a;
        cm.y = clipInfo.b;
        cm.z = clipInfo.c;
        cm.w = clipInfo.d;
        shaderValue.clipMatDir = cm;
        var cmp = shaderValue.clipMatPos;
        cmp.x = clipInfo.tx;
        cmp.y = clipInfo.ty;
        shaderValue.clipMatPos = cmp;
        submit.clipInfoID = this._clipid;
        for (var i = 0; i < n; i += 3) {
            _mesh.addQuad(this._data[i], this._data[i + 1], this._data[i + 2], true);
            CharSubmitCache.__posPool[CharSubmitCache.__nPosPool++] = this._data[i];
        }
        this._ndata = 0;
        if (RenderInfo.loopCount % 100 == 0)
            this._data.length = 0;
        ctx.drawLeftData();
    }
}
CharSubmitCache.__posPool = [];
CharSubmitCache.__nPosPool = 0;
